export default "__VITE_ASSET__BDhnfRGQ__"